import AdvertisingBusinessCard from './AdvertisingBusinessCard.component';

export default AdvertisingBusinessCard;